import { useEffect, useState } from 'react';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import ChangePasswordPanel from './ChangePasswordPanel';
import { useAuth } from '../../../Providers/AuthProvider';
import LoadingSpinner from '../../Components/LoadingSpinner';

const PasswordChangeCard = ({ user }) => {
    const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
    const [userPassword, setUserPassword] = useState('')
    const [isPasswordLoading, setIsPasswordLoading] = useState(false)

    const handleChangePasswordButtonClick = () => {
        setIsChangePasswordVisible(true);
    }

    return (
        <div>
            <div className='row justify-content-center mt-2'>
                <div className='justify-content-center'>
                    <div>
                        <ChangePasswordPanel
                            user={user}
                            isChangePasswordVisible={isChangePasswordVisible}
                            setIsChangePasswordVisible={setIsChangePasswordVisible}
                        />
                        <div className='panel-header-title'>Twoje hasło</div>
                        <button className='btn-app-secondary mt-3' onClick={handleChangePasswordButtonClick}>
                            Zmień hasło
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PasswordChangeCard;